import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { EpisodeCard } from "../components/EpisodeCard";

export default function Episodes() {
    const [episodes, setEpisodes] = useState([]);

    useEffect(() => {
        api.get("/episodes").then((r) => setEpisodes(r.data || []));
    }, []);

    return (
        <div data-testid="episodes-page" className="px-6 md:px-12 lg:px-20 py-20 md:py-28">
            <div className="max-w-4xl mb-16">
                <div className="eyebrow text-[#B8860B] mb-6">The Archive</div>
                <h1 className="font-serif text-5xl md:text-7xl tracking-tight leading-[1] mb-6">All Episodes</h1>
                <p className="text-lg text-black/65 font-light max-w-2xl">
                    Every conversation we've recorded — from quiet to thunderous. Listen in any order.
                </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-14">
                {episodes.map((ep) => <EpisodeCard key={ep.id} episode={ep} />)}
            </div>
        </div>
    );
}
